import PropTypes from 'prop-types';
import { endPoints as PosEndPoints } from '../../../constants/PosConstants';
import AjaxPromises from '../../../utils/AjaxPromises';
import NotificationActions from '../../../actions/NotificationActions';
import UserStore from '../../../stores/UserStore';

class MNApprovalCode extends React.Component {

    constructor(props) {
        super(props);
        this.state={
            ApprovalCode: '',
        };

        this.saveApprovalCode = this.saveApprovalCode.bind(this);
    }

    componentDidMount() {
        this.setState({ ApprovalCode: this.props.ApprovalCode});
    }

    saveApprovalCode() {
        AjaxPromises.POST(PosEndPoints.SET_MN_APPROVAL_CODE, UserStore.getApiData({
            ShipmentId: this.props.ShipmentId,
            ApprovalCode: this.state.ApprovalCode,
        })).then(res => {
            if(!res.Result) {
                NotificationActions.addNotification({
                    type : 'error',
                    body : 'Error saving Approval Code'
                });
            } else {
                
            }
        });
    }

    render() {
        return <div className='checkout-input'>
                    <div className='checkout-input__title'>APPROVAL CODE<span style={{color: 'red', fontSize: 'large'}}>*</span></div>
                    <input 
                        disabled={this.props.disabled}
                        value={this.props.ApprovalCode}
                        style={{
                            position: 'absolute',
                            width: '130px',
                        }}
                        type='text'
                        onChange={(x) => {
                            this.props.onApprovalCodeChange(x.target.value);
                        }}
                    />
                </div>;
    }
}
MNApprovalCode.propTypes = {
    ApprovalCode: PropTypes.any.isRequired,
    onApprovalCodeChange: PropTypes.func.isRequired,
};
export default MNApprovalCode;


// WEBPACK FOOTER //
// ./ui_src/app/components/pos/checkout/MNApprovalCode.react.jsx